/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for a reverse osmosis system.
 */
export type AnimaticReverseOsmosisConfig = {};

/** @internal */
export const AnimaticReverseOsmosisConfig$inboundSchema: z.ZodType<
  AnimaticReverseOsmosisConfig,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AnimaticReverseOsmosisConfig$Outbound = {};

/** @internal */
export const AnimaticReverseOsmosisConfig$outboundSchema: z.ZodType<
  AnimaticReverseOsmosisConfig$Outbound,
  z.ZodTypeDef,
  AnimaticReverseOsmosisConfig
> = z.object({});

export function animaticReverseOsmosisConfigToJSON(
  animaticReverseOsmosisConfig: AnimaticReverseOsmosisConfig,
): string {
  return JSON.stringify(
    AnimaticReverseOsmosisConfig$outboundSchema.parse(
      animaticReverseOsmosisConfig,
    ),
  );
}
export function animaticReverseOsmosisConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticReverseOsmosisConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticReverseOsmosisConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticReverseOsmosisConfig' from JSON`,
  );
}
